export default "https://assets.pclncdn.com/web/next-landing/aa74b141/_next/static/images/hotel-vip-promo-2x-b68b6b81b0ae53d5e22cdf21987fec4f.webp";